// extracted by mini-css-extract-plugin
export default {"custom_date":"dataCount_custom_date__x8Q4R","date_label":"dataCount_date_label__B4KIh"};